import IconGooglePlayWhite from '@/assets/svg/IconGooglePlayWhite.svg';
import IconappStore from '@/assets/svg/IconappStore.svg';
import { getStorageUrl } from '@/utils/utils';
import { IconArrowLeftSlide, IconArrowRightSlide } from '../icons/MainIcons';
import { useState } from 'react';

type SliderItem = {
    title: string;
    image: string;
    content: string;
    platforms?: string[];
    google_play_link?: string;
    app_store_link?: string;
};

type MobileAppPanelProps = {
    slider: SliderItem[];
};

const MobileAppPanel: React.FC<MobileAppPanelProps> = ({ slider = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slider.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + slider.length) % slider.length);
    };

    const currentSlider = slider[currentIndex] || {};

    return (
        <div className="flex items-center justify-center relative w-full">
            <div className="lg:mt-[80px] md:mt-[65px] sm:mt-[50px] mt-[40px] flex items-center justify-center relative w-full">
                {/* Prev */}
                <button
                    onClick={handlePrev}
                    className="arrowSlideFooter absolute lg:-left-[27px] md:-left-[23px] left-[0px]"
                >
                    <IconArrowLeftSlide className="iconArrow" />
                </button>

                <div className="MobileApp w-full grid lg:grid-cols-2 grid-cols-1 overflow-hidden gap-3 border border-white/20">
                    <div className="py-[55px] flex flex-col lg:pr-[80px] pr-0 relative w-full text-center lg:text-right lg:px-0 px-[22px]">
                        <h3
                            className="leading-[1] headFooter w-full text-Grey20"
                            dangerouslySetInnerHTML={{ __html: currentSlider.title || '' }}
                        />
                        <p className="lg:text-[24px] md:text-[20px] text-[16px] font-medium text-Grey20 md:mt-[20px] mt-[16px] lg:mb-[64px] md:mb-[50px] sm:mb-[40px] mb-[32px]">
                            {currentSlider.content || ''}
                        </p>
                        <div className="flex md:gap-[23px] sm:gap-4 gap-3 lg:mx-0 mx-auto">
                            {/*  Google Play */}
                            {currentSlider.platforms?.includes('google_play') && (
                                <button
                                    onClick={() => {
                                        if (currentSlider.google_play_link) {
                                            window.open(currentSlider.google_play_link, '_blank');
                                        }
                                    }}
                                >
                                    <img
                                        src={IconGooglePlayWhite}
                                        alt="Google Play"
                                        className="lg:max-w-[160px] md:max-w-[150px] max-w-[130px]"
                                    />
                                </button>
                            )}

                            {/* App Store */}
                            {currentSlider.platforms?.includes('app_store') && (
                                <button
                                    onClick={() => {
                                        if (currentSlider.app_store_link) {
                                            window.open(currentSlider.app_store_link, '_blank');
                                        }
                                    }}
                                >
                                    <img
                                        src={IconappStore}
                                        alt="App Store"
                                        className="lg:max-w-[160px] md:max-w-[150px] max-w-[130px]"
                                    />
                                </button>
                            )}

                            {/* {currentSlider.platforms.includes('website') && (
                            <button
                                onClick={() => {
                                    if (currentSlider.website_link) {
                                        window.open(currentSlider.website_link, '_blank');
                                    }
                                }}
                            >
                                <img
                                     src={IconappStore}
                                    alt="Website"
                                    className="lg:max-w-[160px] md:max-w-[150px] max-w-[130px]"
                                />
                            </button>
                        )}

                        {currentSlider?.platforms.includes('tv') && (
                            <button
                                onClick={() => {
                                    if (currentSlider.tv_link) {
                                        window.open(currentSlider.tv_link, '_blank');
                                    }
                                }}
                            >
                                <img
                                   src={IconappStore}
                                    alt="TV"
                                    className="lg:max-w-[160px] md:max-w-[150px] max-w-[130px]"
                                />
                            </button>
                        )} */}
                        </div>
                    </div>

                    <div className="lg:flex hidden items-end pt-[55px]">
                        <img
                            src={getStorageUrl(currentSlider.image)}
                            alt="Wooden"
                            className="h-full object-cover md:h-[425px] xl:w-[570px] w-[500px]"
                        />
                    </div>
                </div>

                {/* Next */}
                <button
                    onClick={handleNext}
                    className="arrowSlideFooter absolute lg:-right-[27px] md:-right-[23px] right-[0px]"
                >
                    <IconArrowRightSlide className="iconArrow" />
                </button>
            </div>
        </div>
    );
};

export default MobileAppPanel;
